import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "left",
  "use": "left-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"left\"><path d=\"M318.875 540.125l337.5 300c15 13.125 39.375 13.125 52.5-3.75 13.125-15 13.125-39.375-3.75-52.5L399.5 512l305.625-271.875c15-13.125 16.875-37.5 3.75-52.5-7.5-7.5-16.875-13.125-28.125-13.125-9.375 0-16.875 3.75-24.375 9.375l-337.5 300c-7.5 7.5-13.125 16.875-13.125 28.125s3.75 20.625 13.125 28.125z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol